import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query'
import {
  checklistTemplateKeys,
  checklistTemplateEditorMutationKeys,
  RequestTypes,
} from '@core/react-query/features/templates/checklistTemplates'
import { RequestErrorType } from '@core/utils/api-axios-instance'
import { IProjectApprovalsAssignments } from '@core/entities/project/ProjectApprovalsAssignments'

export const useUpdateProjectChecklistApprovalsAssignments = (
  options?: UseMutationOptions<
    IProjectApprovalsAssignments,
    RequestErrorType,
    RequestTypes['updateProjectChecklistApprovalsAssignments']
  >,
) => {
  const queryClient = useQueryClient()
  return useMutation({
    ...checklistTemplateEditorMutationKeys.updateProjectApprovalsAssignments,
    ...options,
    onSuccess: (_data, variables) => {
      queryClient.invalidateQueries(
        checklistTemplateKeys.getProjectApprovalsAssignments({
          organisationId: variables.organisationId,
          projectId: variables.projectId,
          templateId: variables.templateId,
          templateVersionId: variables.templateVersionId,
        }).queryKey,
      )
    },
  })
}
